(function ($, Cobalt, undefined) {
    Cobalt.ImageTagging = function (settings) {
        this.bind(settings);
        var tagger = this;

        // Change this?
        if (settings.initializeTaggingButton) {
            $(document).ready(function () {
                tagger.autoStartTagging = false;
                tagger.initialize();
            });

            $(settings.initializeTaggingButton).click(function (e) {
                e.preventDefault();

                tagger.autoStartTagging = true;
                if (!tagger.initialized) {
                    tagger.initialize();
                }
                else {
                    if (tagger.enableEditing) {
                        if (tagger.taggingStarted) {
                            tagger.stopTagging();
                        } else {
                            tagger.startTagging();
                        }
                    }
                }
            });
        } else {
            Cobalt.runOnLoad(function () {
                $(window).load(function () {
                    tagger.initialize();
                });

                // TODO : Was double initiaiizing, confirm this doesn't break anything
                if ($(tagger.imageSelector)[0].complete) {
                    //tagger.initialize();
                }
            });
        }
    };

    Cobalt.ImageTagging.prototype = {
        bind: function (settings) {
            this.imageOwner = settings.imageOwner;
            this.autoStartTagging = settings.autoStartTagging || false;
            this.enableEditing = settings.enableEditing === undefined ? this.imageOwner === Cobalt.User.userID : settings.enableEditing;
            this.imageSelector = settings.imageSelector;
            this.imageParent = settings.imageParent;
            this.initializeTaggingButton = settings.initializeTaggingButton;
            this.tagButton = settings.tagButton;
            this.tagSelector = settings.tagSelector;
            this.tagList = settings.tagList;
            this.availableTags = settings.availableTags;
            this.initialTags = settings.initialTags;
            this.tags = new Array();
            this.onTagAdded = settings.onTagAdded;
            this.onTagRemoved = settings.onTagRemoved;
            this.nextColorIndex = 1;
            this.tagColorIndex = new Array();
            this.taggingStarted = false;
            this.initialized = false;
            this.onAreaSelected = settings.onAreaSelected;
            this.createTag = settings.createTag;
            this.createDeleteLink = settings.createDeleteLink;
            this.onSelectChange = settings.onSelectChange;
            this.onInitialized = settings.onInitialized;
        },
        initialize: function () {
            var tagger = this;

            $(tagger.tagButton).click(function () {
                tagger.handleTagButton.call(tagger);
            });
            $(tagger.tagButton).enable(false);

            var tagSelector = $(tagger.tagSelector);
            $.each(tagger.availableTags, function () {
                var option = $('<option>').text(this.name).attr('value', this.id);
                tagSelector.append(option);
            });

            $.each(tagger.initialTags, function () {
                tagger.createTaggedRegion(this.id, this.name, this.rect, this);
            });
            if (tagger.enableEditing && this.autoStartTagging) {
                tagger.startTagging();
            }

            if (!!tagger.onInitialized) {
                tagger.onInitialized();
            }

            tagger.initialized = true;
        },
        clearSelection: function () {
            if (this.imgAreaSelect) {
                this.imgAreaSelect.cancelSelection();
            }
        },
        startTagging: function () {
            var tagger = this;
            $(tagger.imageParent).find(".tag-wrapper").hide();
            $(tagger.imageSelector).each(function () {
                tagger.imgAreaSelect = $(this).imgAreaSelect({
                    handles: false,
                    enable: true,
                    onSelectEnd: function (img, selection) {
                        tagger.handleSelection.call(tagger, img, selection);
                    },
                    onSelectChange: tagger.onSelectChange
                }).data('imgAreaSelect');
            });
            $(tagger.imageSelector).css("cursor", "crosshair");
            tagger.taggingStarted = true;
        },
        stopTagging: function () {
            var tagger = this;
            $(tagger.imageSelector).each(function () {
                tagger.imgAreaSelect.remove();
            });
            tagger.taggingStarted = false;
            $(tagger.imageSelector).css("cursor", "default");
            tagger.initialized = false;
        },
        handleSelection: function (img, selection) {
            selection.x1 /= img.width;
            selection.x2 /= img.width;
            selection.y1 /= img.height;
            selection.y2 /= img.height;

            // Require 10 pixels
            if (selection.width > 10 && selection.height > 10) {
                $(this.tagButton).enable(true);
            } else {
                $(this.tagButton).enable(false);
            }
            selection.height /= img.height;
            selection.width /= img.width;

            this.selection = selection;
            if (this.onAreaSelected !== undefined) {
                this.onAreaSelected(img, { "Value": selection });
            }
        },
        handleTagButton: function () {
            var tagName = $(tagger.imageParent).find(this.tagSelector + ' option:selected').text();
            var tagValue = $(tagger.imageParent).find(this.tagSelector).val();
            this.createTaggedRegion(tagValue, tagName, this.selection);

            if (this.onTagAdded != null) {
                this.onTagAdded(tagValue, tagName, this.selection);
            }

        },

        createTaggedRegion: function (tagId, tagName, rect, data) {
            var tagUrl;

            if (!!data) {
                tagUrl = data.url;
            } else if (this.availableTags[tagId] != null) {
                tagUrl = this.availableTags[tagId].url;
            }

            tagUrl = tagUrl || '#';

            var tagDiv = $("<div>").addClass("tag-wrapper");

            var tagLink = this.createTag(tagId, tagName, tagUrl, data);
            var imageParent = $(this.imageParent);
            var img = imageParent.find(this.imageSelector);
            var borderLeftOffset = parseInt(tagLink.css("border-left-width").replace("px", "") || "0");
            var borderTopOffset = parseInt(tagLink.css("border-top-width").replace("px", "") || "0");
            var leftOffset = ((imageParent.width() - img.width()) / 2) - borderLeftOffset;
            var topOffset = ((imageParent.height() - img.height()) / 2) - borderTopOffset;
            var top = (rect.y1 * img.height()) + topOffset;
            var left = (rect.x1 * img.width()) + leftOffset;
            tagLink.css('top', top);
            tagLink.css('left', left);
            tagLink.width(rect.width * img.width());
            tagLink.height(rect.height * img.height());

            if (this.createDeleteLink) {
                var deleteLink = this.createDeleteLink(rect, img, imageParent, tagLink);
                tagDiv.append(deleteLink);
            }
            imageParent.append(tagDiv.append(tagLink));
            Cobalt.triggerHtmlInsert(imageParent);
            if (this.imgAreaSelect != null) {
                this.imgAreaSelect.setOptions({ hide: true });
            }

            if (this.tagColorIndex[tagId] === undefined) {
                this.tagColorIndex[tagId] = this.nextColorIndex++;
            }

            if (this.availableTags[tagId] != null) {
                if (this.tags[tagId] == null) {
                    this.tags[tagId] = tagName;

                    var newTag = $('<li>').attr('data-tag-id', tagId);
                    var legendEntry = $('<span>'); // TODO: Change to use Cobalt markup.
                    legendEntry.addClass('tag-legend').addClass('image-tag-' + this.tagColorIndex[tagId]);
                    var legendLink = $(document.createElement('A'));
                    legendLink.attr('href', tagUrl).attr('title', tagName).text(tagName);
                    newTag.append(legendEntry);
                    newTag.append(legendLink);

                    if (this.enableEditing) {
                        // Add Delete button
                        var deleteButton = $('<span>'); // TODO: Change to use Cobalt markup.
                        deleteButton.addClass("icon delete");
                        deleteButton.attr('title', "Remove tag");
                        deleteButton.html('delete');
                        deleteButton.attr('data-tag-id', tagId);
                        deleteButton.click(function () {
                            tagger.handleDeleteClicked($(this));
                        });
                        newTag.append(deleteButton);
                    }

                    $(this.tagList).append(newTag);

                    // TODO: Use hide and show methods. Alter css selectors accordingly.
                    newTag.hover(function () {
                        var tag = $(this);
                        imageParent.find('.image-tag[data-tag-id=' + tag.attr('data-tag-id') + ']').addClass('show');
                    }, function () {
                        var tag = $(this);
                        imageParent.find('.image-tag[data-tag-id=' + tag.attr('data-tag-id') + ']').removeClass('show');
                    });
                }
            }
            else {
                var existingTag = $(this.tagList).find("[data-tag-id='" + tagId + "']");
                existingTag.hover(function () {
                    var tag = $(this);
                    imageParent.find('.image-tag[data-tag-id=' + tag.attr('data-tag-id') + ']').addClass('show');
                }, function () {
                    var tag = $(this);
                    imageParent.find('.image-tag[data-tag-id=' + tag.attr('data-tag-id') + ']').removeClass('show');
                });
            }

            // TODO: Use hide and show methods. Alter css selectors accordingly.
            tagLink.hover(function () {
                var tag = $(this);
                imageParent.find('.image-tag[data-tag-id=' + tag.attr('data-tag-id') + ']').addClass('show');
            }, function () {
                var tag = $(this);
                imageParent.find('.image-tag[data-tag-id=' + tag.attr('data-tag-id') + ']').removeClass('show');
            });
            // add tag color style
            tagLink.addClass('image-tag-' + this.tagColorIndex[tagId]);
            $(this.tagButton).enable(false);
        },

        showTag: function (tagID) {
            var imageParent = $(this.imageParent);
            imageParent.find('.image-tag[data-tag-id=' + tagID + ']').addClass('show');
        },

        unshowTag: function (tagID) {
            var imageParent = $(this.imageParent);
            imageParent.find('.image-tag[data-tag-id=' + tagID + ']').removeClass('show');
        },

        createTag: function (tagId, tagName, tagUrl) {
            var tagDiv = $("<a>");
            tagDiv.addClass('image-tag no-tooltip').attr('title', tagName).attr('data-tag-id', tagId).attr('href', tagUrl);
            return tagDiv;
        },

        handleDeleteClicked: function (button) {
            var tagId = button.attr('data-tag-id');
            var tagName = this.tags[tagId];
            if (!confirm('Remove all tags for ' + tagName + '?')) return;
            if (this.onTagRemoved != null) {
                this.onTagRemoved(tagId);
            }
            $(this.imageParent).find('.image-tag[data-tag-id=' + tagId + ']').remove();
            button.parent().remove();
            this.tags[tagId] = null;
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ImageTagging.js